import { alpha } from "@mui/material/styles";

import { error, info, neutral, success, warning } from "../colors";

import { getPrimary } from "../utils";

import type { PaletteOptions } from "@mui/material";
import type { ColorPreset, Contrast } from "../index";

interface Config {
	colorPreset?: ColorPreset;
	contrast?: Contrast;
}

export const createPalette = (config: Config): PaletteOptions => {
	const { colorPreset, contrast } = config;

	return {
		action: {
			active: neutral[500],
			disabled: alpha(neutral[100], 0.38),
			disabledBackground: alpha(neutral[100], 0.12),
			focus: alpha(neutral[100], 0.16),
			hover: alpha(neutral[100], 0.04),
			selected: alpha(neutral[100], 0.12),
		},
		background: {
			default: contrast === "high" ? "#0A0A09" : "#11110F",
			paper: neutral[900],
		},
		divider: "#4A4944",
		error,
		info,
		mode: "dark",
		neutral,
		primary: getPrimary(colorPreset),
		success,
		text: {
			primary: "#E8E6E2",
			secondary: "#A3A19A",
			disabled: "rgba(255, 255, 255, 0.48)",
		},
		warning,
	};
};
